import { SvgIcon, type SvgIconProps } from './svgIcon'

type Props = SvgIconProps & {
  fillColor?: string
  strokeColor?: string
}

export function IdCardIcon({ width = 20, height = 16, ...props }: Props) {
  return (
    <SvgIcon
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      {...props}>
      <path
        d="M12.0769 8.73073H16.6153V7.23075H12.0769V8.73073ZM12.0769 5.84613H16.6153V4.34615H12.0769V5.84613ZM3.38463 11.6538H10.6923V11.2961C10.6923 10.6295 10.3625 10.1057 9.70285 9.72498C9.04323 9.34421 8.1551 9.15383 7.03845 9.15383C5.92178 9.15383 5.03364 9.34421 4.37403 9.72498C3.71443 10.1057 3.38463 10.6295 3.38463 11.2961V11.6538ZM7.03845 7.84613C7.52433 7.84613 7.93747 7.67593 8.27785 7.33555C8.61823 6.99517 8.78843 6.58203 8.78843 6.09613C8.78843 5.61024 8.61823 5.19711 8.27785 4.85673C7.93747 4.51634 7.52433 4.34615 7.03845 4.34615C6.55255 4.34615 6.13941 4.51634 5.79903 4.85673C5.45864 5.19711 5.28845 5.61024 5.28845 6.09613C5.28845 6.58203 5.45864 6.99517 5.79903 7.33555C6.13941 7.67593 6.55255 7.84613 7.03845 7.84613ZM0.5 15.5V0.5H19.5V15.5H0.5ZM1.99998 14H18V1.99998H1.99998V14Z"
        fill="currentColor"
      />
    </SvgIcon>
  )
}
